<div class="rfp-container">
    <img src="../../../../assets/icons/logo.svg" alt="Mercer" class="logo-image" />
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
    <div class="frp-buttons-container">
        <button class="landing_btn" (click)="onFirstButtonClick.emit()">
            <h2>{{ firstButtonText }}</h2>
        </button>
        <button class="landing_btn" (click)="onSecondButtonClick.emit()">
            <h2>{{ secondButtonText }}</h2>
        </button>
    </div>
    <div class="footer">
        <img
            src="../../../../assets/icons/LenAI-3.svg"
            alt="Powered by LenAI"
            class="len-ai-image"
        />
        <button class="back-button" [routerLink]="[path]" *ngIf="firstButtonText === 'Darwin UK'">
            <img src="/assets/icons/icon-chevron-24-left.svg" alt="Prev" />
            <span>Prev</span>
        </button>
    </div>
</div>
